<script setup>

import router from "@/router";
import {onMounted} from "vue";

onMounted(() => {
  router.push('/game');
})

</script>

<template>
  hi
</template>